import { type EnvironmentProviders, makeEnvironmentProviders, type Provider, type Type } from '@angular/core';

import type { AddressAutocompleteProvider } from '@arya/shared/address-autocomplete-contract';

import { NominatimAddressAutocompleteProvider } from './nominatim-address-autocomplete-provider';
import { PhotonAddressAutocompleteProvider } from './photon-address-autocomplete-provider';
import { PHOTON_URL } from './photon-url';
import { provideAddressAutocomplete } from './provide-address-autocomplete';

export type GeocoderProviderId = 'nominatim' | 'photon';

export type GeocoderConfig =
  | { readonly provider: 'nominatim' }
  | { readonly provider: 'photon'; readonly photonUrl?: string };

const GEOCODER_DRIVERS: Record<GeocoderProviderId, Type<AddressAutocompleteProvider>> = {
  nominatim: NominatimAddressAutocompleteProvider,
  photon: PhotonAddressAutocompleteProvider,
};

const photonUrlOverride = (config: GeocoderConfig): readonly Provider[] =>
  config.provider === 'photon' && config.photonUrl !== undefined
    ? [{ provide: PHOTON_URL, useValue: config.photonUrl }]
    : [];

export const provideGeocoder = (config: GeocoderConfig): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideAddressAutocomplete(GEOCODER_DRIVERS[config.provider]),
    ...photonUrlOverride(config),
  ]);
